<ng-container
  *ngIf="{
    isTitleValid: isTitleValid$ | async,
    titleValidationErrMsg: titleValidationErrMsg$ | async
  } as viewModel"
>
  <app-pencil-bottom-sheet-container
    [title]="data.title"
    [hasArrowBack]="true"
    (closeClicked)="handleCancel()"
    (backClicked)="handleBackClick()"
    [colorScheme]="data.colorScheme"
  >
    <div class="content">
      <input
        #input
        type="text"
        [value]="data.value"
        [class.light-scheme]="data.colorScheme === ColorScheme.LIGHT"
        (keyup)="validateTitle()"
      />
      <div class="controls">
        <app-pencil-button
          (clickEvent)="handleCancel()"
          class="cancel"
          [theme]="PencilButtonThemeEnum.SECONDARY"
        >
          <app-pencil-icon type="mat-icon" name="close"></app-pencil-icon>
          {{ 'Cancel' | translate }}
        </app-pencil-button>

        <div
          class="confirm-button-container"
          [appTooltip]="invalidSessionTitleTooltip"
          [appTooltipPlacement]="'top-center'"
          [appTooltipDisabled]="viewModel.isTitleValid"
        >
          <app-pencil-button
            (clickEvent)="handleConfirm()"
            class="confirm"
            [theme]="PencilButtonThemeEnum.PRIMARY"
            [disabled]="!viewModel.isTitleValid"
          >
            <app-pencil-icon
              type="svg-icon"
              [name]="viewModel.isTitleValid ? 'edit-pencil-white' : 'edit-pencil-disabled'"
            ></app-pencil-icon>
            {{ 'Rename' | translate }}
          </app-pencil-button>
        </div>
      </div>
    </div>
  </app-pencil-bottom-sheet-container>

  <ng-template #invalidSessionTitleTooltip>
    <app-tooltip [text]="viewModel.titleValidationErrMsg" [arrow]="'bottom'"></app-tooltip>
  </ng-template>
</ng-container>
